<template>
  <div class="aboutUs">
    <div class="topPart">
      <img src="@/assets/image/logo.png" alt="" class="logo" />
      <div class="companyName"><span>搜货精</span>选</div>
      <div v-if="getIsApp" class="version">版本：{{ versionCode }}</div>
    </div>
    <div class="itemGroup">
      <div v-for="(item, index) in cellList" :key="index" class="itemCell tapActive" @click="$router.push(item.routerName)">
        <div class="leftPart">
          <span :class="item.iconfont" class="iconfont icon"></span>
          <div class="text" v-text="item.name"></div>
        </div>
        <i class="iconfont icon-jiantou iconRight"></i>
      </div>
    </div>
    <div class="emptyBox" style="height: 40px"></div>
    <!-- <div class="bottomBox">韶关市搜货精选信息科技有限公司</div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AboutUs',
  computed: {
    ...mapGetters(['getIsApp', 'versionCode'])
  },
  data() {
    return {
      cellList: [
        // {
        //   iconfont: "icon-ERP_xieyibianhao",
        //   name: "平台协议",
        //   routerName: "platformProtocol",
        // },
        {
          iconfont: 'icon-Bookmark',
          name: '隐私协议',
          routerName: 'privacyAgreement'
        },
        {
          iconfont: 'icon-yonghu',
          name: '用户协议',
          routerName: 'userAgreement'
        }
      ]
    }
  },
  created() {
    // if (!this.getIsApp) {
    //   this.cellList = this.cellList.splice(0, 1);
    // }
  }
}
</script>

<style lang="scss" scoped>
.aboutUs {
  display: flex;
  flex-direction: column;
  padding: 0 30px 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #fff;

  .topPart {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 51px 0 37px;

    .logo {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }

    .companyName {
      font-size: 20px;
      font-weight: 700;
      margin: 12px 0;
      span {
        letter-spacing: 12px;
      }
    }

    .version {
      color: #898989;
    }
  }

  .itemGroup {
    width: 100%;

    .itemCell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      border-bottom: 1px solid #f2f2f2;

      .leftPart {
        display: flex;
        align-items: center;
        font-size: 14px;

        .icon {
          font-size: 20px;
          margin-right: 10px;
        }
      }

      .iconRight {
        font-size: 12px;
      }
    }
  }

  .bottomBox {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    color: #cfcfcf;
    width: 100%;
    height: 40px;
    flex: 1;
    background-color: #fff;
    font-size: 14px;
  }
}
</style>
